import React from 'react';
import classNames from 'classnames';
import MymeTypeIcon from 'router/subrouters/DataRoom/components/DataRoomDocumentsRouter/components/MymeTypeIcon';
import { FilePreview as FilePreviewType } from 'models/File';

import './FilePreview.styles.scss';

type FilePreviewProps = {
  className?: string;
} & Pick<FilePreviewType, 'type'>;

const FilePreview: React.FC<FilePreviewProps> = (props) => {
  const { className, type } = props;

  const classes = classNames('file-preview', type, className);

  return (
    <div className={classes}>
      <div className="wrapper">
        <MymeTypeIcon mimeType={type} />
      </div>
    </div>
  );
};

export default FilePreview;
